import * as React from "react";
import { Event } from "../../../../../contracts";
import { renderSportIcon } from "./renderSportIcon";
import { renderGameState } from "./renderGameState";
import { BaseDict } from "../../../dict";

export const renderGameStateWrapper = (event: Event, componentPrefix: string, isDesktop: boolean, dict: BaseDict ) =>
    isDesktop ?
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`} data-uat={`div-ev-list-${componentPrefix}-clock`}>
            {renderSportIcon(event.sportId)}
            {renderGameState(event.isLive, event.id, event.gamePart, event.gameTime, componentPrefix, dict)}
        </div>
        : !event.isInKickOffState && renderGameState(event.isLive, event.sportId, event.gamePart, event.gameTime, componentPrefix, dict);
